import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../../util/varios";
import useTableFijo from "../../useTableFijo";
import { Radio } from "../../../ui/inputs/Input"; // 👈 NUEVO

const TablaDeudasVehiculos = (props) => {
  // 👇 NUEVO: factor de cambio. Soporta tanto número crudo como objeto { valor: X }
  const factorObj =
    props.factorCambio ?? JSON.parse(localStorage.getItem("factorCambio"));
  const factorValor =
    typeof factorObj === "object" && factorObj !== null
      ? factorObj.valor
      : factorObj;
  const factorCambio = Number(factorValor) || 1; // factor numérico seguro

  const [records, setRecords] = useState([]);

  // 👇 NUEVO: 1 = Monto en Bs. / 0 = Monto en U.C
  const [moneda, setMoneda] = useState(1);

  // 👇 CAMBIADO: antes eran 4 useState separados (deuda, interes, recargo, totDeuda)
  const [montos, setMontos] = useState({
    deuda: 0,
    interes: 0,
    recargo: 0,
    totalDeuda: 0,
  });

  const headCells = [
    {
      id: "anio",
      label: "AÑO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "mes",
      label: "MES",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "monto",
      label: "MONTO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "intereses",
      label: "INTERES MORA",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "recargo",
      label: "RECARGOS",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
  ];

  const [filterFn, setFilterFn] = useState({ fn: (items) => items });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, 220);

  // ================= LÓGICA DE CONVERSIÓN (igual que tu referencia) =================

  // 👇 NUEVO: convierte strings "1234,56" o números a float de forma segura
  const aNumero = (valor) =>
    parseFloat(String(valor ?? 0).replace(",", ".")) || 0;

  // 👇 NUEVO: ¿está marcado el radio "Monto en U.C"? (value = 0)
  const esUc = Number(moneda) === 0;

  // 👇 NUEVO: U.C -> divide entre el factor | Bs -> valor normal
  const convertir = (valor) => {
    const num = aNumero(valor);
    return esUc ? num / factorCambio : num;
  };

  // 👇 NUEVO: convierte y formatea con 2 decimales
  const fmt = (valor) =>
    formatMoneda(convertir(valor).toFixed(2).replace(".", ","), ",", ".", 2);

  // 👇 NUEVO: suma los valores CRUDOS y al final aplica la conversión
  const calcularTotales = (lista) => {
    let deu = 0;
    let inte = 0;
    let reca = 0;
    let desc = 0;

    (lista || []).forEach((item) => {
      deu += aNumero(item.monto);
      inte += aNumero(item.intereses);
      reca += aNumero(item.recargo);
      desc += aNumero(item.descuento);
    });

    setMontos({
      deuda: fmt(deu),
      interes: fmt(inte),
      recargo: fmt(reca),
      totalDeuda: fmt(deu + inte + reca - desc), // igual que antes: resta el descuento
    });
  };

  // 👇 NUEVO: los totales se recalculan al cambiar los datos O el radio Bs/U.C
  useEffect(() => {
    calcularTotales(records);
  }, [records, moneda]);

  // ==================================================================================

  // 👇 CAMBIADO: aquí solo se guardan los datos CRUDOS, sin sumar ni formatear.
  //    Los totales los calcula el useEffect de arriba.
  useEffect(() => {
    if (props.tabdeuda) {
      setRecords(props.tabdeuda);
    }
  }, [props.tabdeuda]);

  // 👇 NUEVO: handler de los radios
  const renderDeuda = (e) => {
    setMoneda(e.target.value); // solo con esto, tabla y totales ya se convierten
  };

  // 👇 CAMBIADO: envía el radio seleccionado y el factor numérico
  const imprimirDeuda = (event) => {
    if (event) event.preventDefault();
    const id = "VEH.IdVehiculo=" + parseInt(props.idvehi);
    const sql1 = null;
    const reporte = "EdoCtaCorto2Vehic";

    window.open(
      op.reportes +
        "/impuestovehiculo?reporte=" +
        reporte +
        "&sql1=" +
        sql1 +
        "&sql=" +
        id +
        "&valpetro=" +
        factorCambio + // antes: props.factorCambio (si llega como objeto imprimía [object Object])
        "&radioBolivares=" +
        moneda, // antes iba fijo en 1. Ahora: 1 = Bs / 0 = U.C
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  let op = require("../../../../src/modulos/datos");

  return (
    <div className="card">
      <div className="card-body" style={{ height: "100%" }}>
        <div className="content mx-auto">
          <div className="container mx-auto">
            <div className="row col-md-12 mx-auto" style={{ height: "100%" }}>
              <div className="row mx-auto">
                <div className="col-md-12 d-flex justify-content-between mb-2">
                  {/* 👇 NUEVO: radios de moneda (Bs / U.C) */}
                  <div className="col-auto m-0 p-0 d-flex gap-2 align-items-start">
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Monto en Bs."
                        onChange={renderDeuda}
                        value={1}
                        name="montoVeh"
                        id="montoBsVeh"
                        defaultChecked
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Monto en U.C"
                        onChange={renderDeuda}
                        value={0}
                        name="montoVeh"
                        id="montoUcVeh"
                      />
                    </div>
                  </div>
                  <button
                    style={{ height: "30px" }}
                    onClick={imprimirDeuda}
                    className="btn btn-sm btn-primary rounded-circle"
                  >
                    <i className="fas fa-print"></i>{" "}
                  </button>
                </div>

                <div className="col-md-12 mx-auto px-0">
                  <TblContainer
                    container={{
                      height: 250,
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />

                    <tbody>
                      {records &&
                        records.map((item, index) => (
                          <tr
                            key={item.anio + item.mes}
                            style={{ padding: "0" }}
                          >
                            <td style={{ fontSize: "10px", textAlign: "left" }}>
                              {item.anio}
                            </td>
                            <td style={{ fontSize: "10px", textAlign: "left" }}>
                              {item.mes}
                            </td>
                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {fmt(item.monto)} {/* 👈 CAMBIADO */}
                            </td>
                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {fmt(item.intereses)} {/* 👈 CAMBIADO */}
                            </td>
                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {fmt(item.recargo)} {/* 👈 CAMBIADO */}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </TblContainer>

                  <div
                    className="col-md-12 border-table mx-auto row px-0"
                    style={{ borderTop: "none" }}
                  >
                    <div className="col-md-8 row mx-auto"></div>
                    <div className="col-md-4 row">
                      <div className="input-group input-group-sm mb-0 col-md-12">
                        <span
                          className="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Deuda:
                        </span>
                        <input
                          type="text"
                          className="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          value={montos.deuda}
                        />
                      </div>

                      <div className="input-group input-group-sm mb-0 col-md-12">
                        <span
                          className="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Intereses de Mora:
                        </span>
                        <input
                          type="text"
                          className="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          value={montos.interes}
                        />
                      </div>

                      <div className="input-group input-group-sm mb-0 col-md-12">
                        <span
                          className="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Recargo por Mora:
                        </span>
                        <input
                          type="text"
                          className="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          value={montos.recargo}
                        />
                      </div>

                      <div className="input-group input-group-sm mb-0 col-md-12">
                        <span
                          className="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Total de la Deuda:
                        </span>
                        <input
                          type="text"
                          className="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          value={montos.totalDeuda}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaDeudasVehiculos;
